module.exports = __webpack_public_path__ + "media/images/icons/outlined/global-42913413a275ac86e34184d75dc2f315.svg";